import "../../App.css";

import React, {useEffect, useRef, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import { useForm, Controller } from 'react-hook-form';
import {Button, Icon, TextField} from "@material-ui/core";
import KontaktHeroSection from "../KontaktHeroSection";
import './Kontakt.css';

function Kontakt() {

	const [result, setResult] = useState();
	const [resultText, setResultText] = useState();

	const { handleSubmit, control, register, errors: fieldsErrors, reset } = useForm();

	async function sendMail(name, email, message) {
		let headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		// headers.append('Access-Control-Allow-Credentials', 'true');
		// headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');

		// headers.append('GET', 'POST', 'OPTIONS');

		const a = 'Au';
		const a1 = 'thorization';
		const b = 'Basic ';
		const b1 = 'YWRtaW46bWF';
		const b2 = 'pbHNlbmRlcg';
		const b3 = '==';

		headers.append(a + a1, b + b1 + b2 + b3);

		const response = await fetch(`/mailer/send.php?from=${email}&message=${message}`, { headers: headers});
		// const response = await fetch(`http://www.e23.cz/mailer/send.php?from=${email}&message=${message}`, { credentials: "same-origin", headers: headers});

		return response;
	}

	const onSubmit = async (data) => {
		const response = await sendMail(data.name, data.email, data.zprava);
		console.log(await response);
		const json = await response.json();
		if (response.status === 200 && json.result === 'ok') {
			setResult(true);
			setResultText("Zpráva byla úspěšně odeslána...");
		} else {
			setResult(false);
			setResultText("Chyba při odesílání zprávy!");
			console.log(response);
			console.log(response.headers);
		}
	};

	return (
		<>
			<KontaktHeroSection/>
			<div className="kontakt-container">
				<div>
					<h1>Jsme tu pro vás, napište</h1>
					<form className="form-container" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
							<FormControl fullWidth variant="outlined">
								<Controller
									name="name"
									as={
										<TextField
											variant="outlined"
											label="Jméno"
											placeholder="Uveďte vaše jméno"
											// fullWidth
											margin="normal"
											style={{ padding: 4 }}
											error={!!fieldsErrors.name}
											helperText={fieldsErrors.name ? fieldsErrors.name.message : null}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									}
									control={control}
									defaultValue=""
									rules={{
										required: "Povinná položka"
									}}
								/>
							</FormControl>

							<FormControl fullWidth variant="outlined">
								<Controller
									name="email"
									as={
										<TextField
											id="email"
											helperText={fieldsErrors.email ? fieldsErrors.email.message : null}
											variant="outlined"
											label="Email"
											placeholder="Emailová adresa"
											fullWidth
											margin="normal"
											style={{ padding: 4 }}
											error={!!fieldsErrors.email}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									}
									control={control}
									defaultValue=""
									rules={{
										required: 'Povinná položka',
										pattern: {
											value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
											message: 'Neplatná emailová adresa'
										}
									}}
								/>
							</FormControl>

							<FormControl fullWidth variant="outlined">
								<Controller
									name="zprava"
									as={
										<TextField
											id="zprava"
											helperText={fieldsErrors.zprava ? fieldsErrors.zprava.message : null}
											variant="outlined"
											label="Zpráva"
											placeholder="Text zprávy"
											fullWidth
											margin="normal"
											style={{ padding: 4 }}
											rows={6}
											multiline
											error={!!fieldsErrors.zprava}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									}
									control={control}
									defaultValue=""
									rules={{
										required: 'Povinná položka'
									}}
								/>
							</FormControl>
						<Button
							variant="contained"
							color="primary"
							endIcon={<Icon>send</Icon>}
							type="submit"
						>
							Odeslat
						</Button>
						{ resultText && <div className={result ? "result-ok" : "result-error"}>{resultText}</div> }
					</form>
				</div>

				<div className="kontakt">
					<h1 className="nadpis">KONTAKT</h1>
					<h2 className="podnadpis">ADRESA</h2>
					<p>Bořivojova 86</p>
					<p>397 01 Písek, Česká republika</p>

					<h2 className="podnadpis">EMAIL</h2>
					<p>info@e23.cz</p>
				</div>
			</div>
		</>
	);
}

export default Kontakt;